










































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import Placeholder from '../../../components/Placeholder.vue';
import {DeviceFunction, DeviceVersionInterface, Interface} from '@/types';
import InterfaceService from '@/services/interface.service';
import Table from '@/components/Table.vue';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';
import AceEditor from 'vue2-ace-editor';
import 'brace/mode/javascript';
import 'brace/theme/clouds';

@Component({
  components: {
    AceEditor,
    Table,
    Placeholder,
  },
})
export default class Interfaces extends Vue {
  @Prop({ default: {} }) private deviceType: any;

  private headers: object[] = [
    { text: 'Field', value: 'field_name' },
    { text: 'Type', value: 'type' },
  ];
  private interfaces: Interface[] = [];
  private displayInterfaces: Interface[] = [];
  private currentInterface: any = {};
  private currentFunction: string = '';
  private currentMapping: Partial<DeviceVersionInterface> = {};
  private interfaceMappings: Partial<DeviceVersionInterface[]> = [];
  private activePanel: number | null = null;
  private dirty: boolean = false;
  private saved: Record<number, boolean> = {};

  private async mounted() {
    await this.initInterfaces();
  }

  private async initInterfaces() {
    if (!this.interfaces.length) {
      const interfaces = await InterfaceService.getInterfaces();
      interfaces.sort((a: any, b: any) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      Vue.set(this, 'interfaces', interfaces);
    }
    if (!this.interfaceMappings.length) {
      await this.populateMappings();
    }
    this.displayInterfaces = this.interfaces.filter((i) => !this.interfaceMappings.map((j) => j && j.interface_id).includes(i.id));

  }

  private async populateMappings() {
    const mappings = await AdminDeviceTypeService.getAllInterfaceMappings(this.deviceType.id);
    Vue.set(this, 'interfaceMappings', mappings);

    for (const mapping of mappings) {
      if (mapping.interface_id) {
        this.saved[mapping.interface_id] = true;
      }
    }
  }

  private editorInit(editor: any) {
    editor.setOptions({
      fontSize: '1em',
    });
  }

  private async selectInterface(deviceVersionInterface: DeviceVersionInterface, index: number) {
    this.dirty = true;
    Vue.set(this, 'currentInterface', deviceVersionInterface.interface);
    Vue.set(this, 'currentFunction', deviceVersionInterface.function.function);

    if (deviceVersionInterface.interface_id !== deviceVersionInterface.interface.id) {
      deviceVersionInterface.interface_id = deviceVersionInterface.interface.id;
    }

    this.currentMapping.interface_id = deviceVersionInterface.interface.id;

    Vue.set(this, 'currentMapping', deviceVersionInterface);
    this.currentFunction ? this.currentMapping.function!.function = this.currentFunction : this.currentMapping.function!.function = '(data, msgType) => {\n\treturn {\n\t};\n}';
  }

  private addInterfaceEditor() {
    const mapping: any = {
      function_id: null,
      interface_id: null,
      device_version_id: Number(this.deviceType.id),
      interface: {},
      function: {},
    };
    this.interfaceMappings.push(mapping);

    Vue.set(this, 'currentMapping', mapping);
  }

  private async saveInterfaceFunctions() {
    for (const mapping of this.interfaceMappings) {
      if (mapping) {
        const funcBody = {
          ...mapping.function,
          type: 'interface',
          execution_version: '0',
        };
        const body = {
          device_version_id: Number(this.deviceType.id),
          interface_id: mapping.interface_id,
          function: funcBody,
        };
        if (mapping.function_id && mapping.function) {
          await AdminDeviceTypeService.updateDeviceFunctionForInterface(mapping.function_id, body.function);
        } else if (!mapping.function_id) {
          const newMapping = await AdminDeviceTypeService.addInterfaceMappingWithFunction(this.deviceType.id, body);
          mapping.function_id = newMapping.function_id;
        }
        if (body.interface_id) {
          Vue.set(this.saved, body.interface_id, true);
        }
        this.dirty = false;
        await this.initInterfaces();
      }
    }
  }

  private async removeMappingAndFunction(dvi: DeviceVersionInterface) {
    if (dvi.id) {
      await AdminDeviceTypeService.deleteMapping(this.deviceType.id, dvi.id);
      this.interfaceMappings = this.interfaceMappings.filter((mapping: any) => mapping.id !== dvi.id);
    } else {
      const empty = this.interfaceMappings.find((mapping: any) => !mapping.interface_id);
      if (empty) {
        this.interfaceMappings = this.interfaceMappings.filter((mapping: any) => empty);
      }
    }
    if (dvi.interface_id) {
      const removed = this.interfaces.find((i) => i.id === dvi.interface_id);
      if (removed) {
        this.interfaceMappings = this.interfaceMappings.filter((mapping: any) => mapping.interface_id !== removed.id);
        this.displayInterfaces.push(removed);
        Vue.set(this.saved, dvi.interface_id, false);
      }
    }
    // await this.initInterfaces();
  }
}
